var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
export var RpsPaymentMessageCodes;
(function (RpsPaymentMessageCodes) {
    RpsPaymentMessageCodes["OPEN_WS"] = "OPEN_WS";
    RpsPaymentMessageCodes["GET_CARD_DETAILS"] = "GET_CARD_DETAILS";
    RpsPaymentMessageCodes["GET_TOUCHPOINT_DATA"] = "GET_TOUCHPOINT_DATA";
})(RpsPaymentMessageCodes || (RpsPaymentMessageCodes = {}));
var ReceiptSection;
(function (ReceiptSection) {
    ReceiptSection["Header"] = "Header";
    ReceiptSection["Body"] = "Body";
    ReceiptSection["Footer"] = "Footer";
})(ReceiptSection || (ReceiptSection = {}));
var Status;
(function (Status) {
    Status["Success"] = "Success";
    Status["Failure"] = "Failure";
    Status["Prompt"] = "Prompt";
})(Status || (Status = {}));
var CardDetailsContext;
(function (CardDetailsContext) {
    CardDetailsContext["Payment"] = "Payment";
    CardDetailsContext["NonPayment"] = "NonPayment";
})(CardDetailsContext || (CardDetailsContext = {}));
var EwicEligibilityStatus;
(function (EwicEligibilityStatus) {
    EwicEligibilityStatus["Eligible"] = "Eligible";
    EwicEligibilityStatus["Ineligible"] = "Ineligible";
    EwicEligibilityStatus["Exhausted"] = "Exhausted";
    EwicEligibilityStatus["ExceededPsRecordLimit"] = "ExceededPsRecordLimit";
})(EwicEligibilityStatus || (EwicEligibilityStatus = {}));
var ws;
var pendingPaymentRequests = [];
export var isPendingPaymentRequest = function () { return !!pendingPaymentRequests.length; };
export var getPendingPaymentRequest = function () { return pendingPaymentRequests; };
export var initializePaymentConnection = function (rpsConfig, message, onOpenCallback, onCloseCallback, onErrorCallback) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, pinpadConnection(rpsConfig, message, onOpenCallback, onCloseCallback, onErrorCallback)
                    .then(function () {
                    sendPaymentMessage(RpsPaymentMessageCodes.OPEN_WS, undefined);
                })
                    .catch(function (err) {
                    throw err;
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var pinpadConnection = function (rpsConfig, message, onOpenCallback, onCloseCallback, onErrorCallback) {
    return new Promise(function (resolve, reject) {
        ws = new WebSocket("ws://" + rpsConfig.rpsHostName + ":" + rpsConfig.defaultRpsPort + "/payment");
        ws.onmessage = function (jsonString) {
            var RpsJsonMessage = JSON.parse(jsonString.data);
            switch (RpsJsonMessage.code) {
                case RpsPaymentMessageCodes.GET_TOUCHPOINT_DATA: {
                    sendPaymentMessage(RpsPaymentMessageCodes.GET_TOUCHPOINT_DATA, message);
                    break;
                }
            }
        };
        ws.onopen = function () {
            onOpenCallback && onOpenCallback();
            resolve();
        };
        ws.onclose = function () {
            onCloseCallback && onCloseCallback();
        };
        ws.onerror = function (err) {
            onErrorCallback && onErrorCallback(err);
            reject(err);
        };
    });
};
export var sendPaymentRequest = function (name, message, rpsConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var options;
    return __generator(this, function (_a) {
        pendingPaymentRequests.unshift(name);
        options = {
            method: 'POST',
            url: "/" + name,
            baseURL: "http://" + rpsConfig.rpsHostName + ":" + rpsConfig.defaultRpsPort + "/payment",
            data: message,
        };
        return [2 /*return*/, axios
                .request(options)
                .then(function (response) {
                return response.data;
            })
                .catch(function (err) {
                throw err;
            })
                .finally(function () {
                var index = pendingPaymentRequests.indexOf(name);
                if (index >= 0) {
                    pendingPaymentRequests.splice(index, 1);
                }
            })];
    });
}); };
export var sendPaymentMessage = function (code, message) {
    var data = { code: code, message: message };
    ws === null || ws === void 0 ? void 0 : ws.send(JSON.stringify(data));
};
